<template>
  <AppShell :last-sync="lastSyncAt" />
</template>

<script setup>
import { onMounted } from 'vue';
import { Network } from '@capacitor/network';
import AppShell from '@/ui/AppShell.vue';
import { initDriveSync, lastSyncAt, sync } from '@/features/sync/useDriveSync.js';

initDriveSync();
Network.addListener('networkStatusChange', ({ connected }) => {
  if (connected) sync();
});

onMounted(() => {
  // Relay Google OAuth PKCE code from popup back to opener then close.
  // Only runs in the popup window (window.opener is set).
  if (!window.opener) return;
  const search = new URLSearchParams(window.location.search);
  if (search.has('code') || search.has('error')) {
    window.opener.postMessage(
      { type: 'google-oauth-pkce', code: search.get('code'), error: search.get('error') },
      window.location.origin,
    );
    window.close();
  }
});

</script>
